import { axios } from '../config/axios';

const endPoint = '/project/device/hardware-audit';

// Query parameters of the venue screen: exam filters and dropdowns (tpm=2.0&amt=Active), each
// as its own parameter. Empty ones are not sent.
const toVenueAuditParams = ({ examFilters = {}, facetFilters = {} }) => Object.fromEntries(
    Object.entries({ ...examFilters, ...facetFilters }).filter(([, value]) => value !== undefined && value !== '')
);

// One page of the matching devices of a venue (venueId "all" for every venue), with a count per
// value of each dropdown, the matching count and the total
const getVenueDevices = async (venueId, { page, limit, examFilters, facetFilters }) => {
    return axios.get(`${endPoint}/venues/${venueId}/devices`, {
        params: { page, limit, ...toVenueAuditParams({ examFilters, facetFilters }) }
    });
}

// The venue screen's filter options: venues, drives, courses, batches, exam dates, labs and the dropdowns
const getVenueDeviceFilters = async (venueId) => {
    return axios.get(`${endPoint}/venues/${venueId}/filters`);
}

const downloadVenueDeviceCsv = async (venueId, { examFilters, facetFilters }) => {
    return axios.get(`${endPoint}/venues/${venueId}/download-csv`, {
        params: toVenueAuditParams({ examFilters, facetFilters }),
        responseType: 'blob',
        headers: {
            'Cache-Control': 'no-cache'
        }
    });
}

export { getVenueDevices, getVenueDeviceFilters, downloadVenueDeviceCsv }
